











import Index from './unit/index.vue';
import Edit from './unit/edit.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { Index, Edit },
})
export default class PatrolPlan extends Vue {
  show = true; // 展示主页面或者添加修改页面
  editOrganFlag = 1; // 控制新增机构和编辑机构的显示
  row: object = {}; // 编辑该行的数据
  type: any = '';
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };

  /**
   * @todo 后期需要优化的部分
   * @desc 自定义事件，点击主页编辑改行内容触发，传递该行数据
   * @param1 row： 编辑这一行的数据对象.
   * @returns 暂无
   */
  getRow(row: object, type: any) {
    this.row = row;
    this.type = type;
  }
}
